/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-24 15:13:26
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-25 19:35:40
 */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice"
import { AppThunkApi, RootState } from "../../app/store";
import { DoctorStationBody, DoctorStationDetail, DoctorStationPage, DoctorStationParams, DoctorStationSubmit } from "../../services/doctorStation";
const initialState = {
  DoctorData: [],
  DoctorCurrent: 1,
  DoctorTotal: 0,
  DoctorId: 0,
  DoctorDetail: {},
  
};

export const getDoctorStationAsync = createAsyncThunk<
  void,
  DoctorStationParams,
  AppThunkApi
>("DoctorStation/page", async (params, api) => {
  return send(DoctorStationPage(params), api)
})

export const getDoctorStationDetailAsync = createAsyncThunk<
  void,
  number,
  AppThunkApi
>("DoctorStation/detail", async (id, api) => {
  return send(DoctorStationDetail(id), api)
})

export const DoctorSlice = createSlice({
  name: "doctorStation",
  initialState,
  reducers: {
    setDoctorData(state, action) {
      state.DoctorData = action.payload;
    },
    setDoctorTotal(state, action) {
      state.DoctorTotal = action.payload;
    },
    setDoctorCurrent(state, action) {
      state.DoctorCurrent = action.payload;
    },
    setDoctorId(state, action) {
      state.DoctorId = action.payload;
    },
    setDoctorDetail(state, action) {
      state.DoctorDetail = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getDoctorStationAsync.fulfilled, (state, action: any) => {
      state.DoctorData = action.payload.records;
      state.DoctorCurrent = action.payload.current;
      state.DoctorTotal = action.payload.total;
    });
    builder.addCase(getDoctorStationDetailAsync.fulfilled, (state, action: any) => {
      state.DoctorDetail = action.payload;
    });
  }
});

export const { setDoctorData, setDoctorTotal, setDoctorCurrent, setDoctorId, setDoctorDetail } =
  DoctorSlice.actions;

export const submitDoctorStationAsync = createAsyncThunk<
  void,
  DoctorStationBody,
  AppThunkApi
>("DoctorStation/submit", async (body, api) => {
  return send(DoctorStationSubmit(body), api)
})

export const selectDoctorData = (state: RootState) => state.doctorStation.DoctorData

export const selectDoctorCurrent = (state: RootState) => state.doctorStation.DoctorCurrent

export const selectDoctorTotal = (state: RootState) => state.doctorStation.DoctorTotal

export const selectDoctorId = (state: RootState) => state.doctorStation.DoctorId

export const selectDoctorDetail = (state: RootState) => state.doctorStation.DoctorDetail

export default DoctorSlice.reducer;
